// close, closeAndPeek, closeAndPeekToIdle, idle, peek, tracking
let monkeys = [
  // @ts-ignore
  require('../monkey/TwoFactorSetupMonkeyClose.tgs'),
  // @ts-ignore
  null,
  // require('../monkey/TwoFactorSetupMonkeyCloseAndPeek.tgs'),
  // @ts-ignore
  null,
  // require('../monkey/TwoFactorSetupMonkeyCloseAndPeekToIdle.tgs'),
  // @ts-ignore
  require('../monkey/TwoFactorSetupMonkeyIdle.tgs'),
  // @ts-ignore
  require('../monkey/TwoFactorSetupMonkeyPeek.tgs'),
  // @ts-ignore
  require('../monkey/TwoFactorSetupMonkeyTracking.tgs'),
];

export const getMonkey = index => {
  let monkey = document.createElement('tgs-player');
  monkey.setAttribute('src', monkeys[index]);

  return monkey;
};
